module.exports = __webpack_public_path__ + "static/img/androidd.21f56ed8.png";